import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '@/providers/api-client';

export interface SidebarCounts {
  orders: number;
  'support-tickets': number;
  moderation: number;
  reports: number;
  payments: number;
  messaging: number;
}

/**
 * Хук для получения counts для бейджей в sidebar.
 * Polling каждые 60 секунд для актуальности данных.
 * Не зависит от QueryClientProvider (избегает конфликта версий react-query).
 */
export function useSidebarCounts() {
  const [data, setData] = useState<SidebarCounts | null>(null);

  const fetchCounts = useCallback(async () => {
    try {
      const result = await apiClient.get<SidebarCounts>('/analytics/sidebar-counts');
      setData(result);
    } catch {
      // Ошибка загрузки sidebar counts — не критично
    }
  }, []);

  useEffect(() => {
    fetchCounts();

    const interval = setInterval(fetchCounts, 60_000);
    return () => clearInterval(interval);
  }, [fetchCounts]);

  // При фокусе окна — обновляем
  useEffect(() => {
    const handleFocus = () => { fetchCounts(); };
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [fetchCounts]);

  return { data };
}
